import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConfirmLoanInsuranceModal } from '../../../common/modals';
import { connectModal } from '../../modal/hoc';
import { selectData } from '../../modal/ducks';
import { confirmLoanInsuranceActions, resendSmsCodeLoanRequest } from '../ducks';
import { apiCallIds } from '../api';

const mapStateToProps = state => ({
  loanId: selectData(state, apiCallIds.CONFIRM_LOAN_INSURANCE),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      confirmLoanInsurance: confirmLoanInsuranceActions.request,
      resendSmsCodeLoan: resendSmsCodeLoanRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.CONFIRM_LOAN_INSURANCE)
export default class ConfirmLoanInsurance extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    loanId: PropTypes.string,
  };

  handleResendSmsCode = callbacks => {
    const { actions, loanId } = this.props;
    actions.resendSmsCodeLoan({ loanId, ...(callbacks || {}) });
  };

  handleSubmit = token => {
    const { actions, loanId } = this.props;
    actions.confirmLoanInsurance({ loanId, token });
  };

  render() {
    const { isVisible, isLoading, modalActions, loanId } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <ConfirmLoanInsuranceModal
        hideModal={modalActions.hide}
        isLoading={isLoading}
        onSubmit={this.handleSubmit}
        onResendSmsCode={this.handleResendSmsCode}
        resendCooldownKey={`loan:${loanId}:insurance`}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/ConfirmLoanInsurance.js